export function insertAltTextToImageTag(html: string, altText: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const images = doc.querySelectorAll("img");
  images.forEach((img) => {
    img.setAttribute("alt", altText);
  });
  return doc.body.innerHTML;
}
